<div class="ion-padding amg">
  <div class="amg-fej">
    <h2><ion-icon name="archive-outline"></ion-icon> Adatmegőrzés</h2>
    <form class="amg-nap" (ngSubmit)="betolt()">
      <label>Vizsgált nap <input type="date" name="nap" [(ngModel)]="nap"></label>
      <ion-button size="small" type="submit" [disabled]="fut"><ion-icon slot="start" name="refresh-outline"></ion-icon>Kimutatás</ion-button>
      <ion-button size="small" fill="clear" type="button" *ngIf="masikNap" (click)="maiNap()" [disabled]="fut">Vissza a mai napra</ion-button>
    </form>
  </div>

  <p class="amg-halvany">
    Kiknek az adatai lépték túl a törvényi kezelési időt. A köznevelési intézmény a tanuló és a szülő adatait a
    jogviszony megszűnésétől számított <b>{{ k?.evek?.tanulo || 10 }} évig</b>, az alkalmazottakét és az óraadókét –
    ha törvény eltérő határidőt nem állapít meg – <b>{{ k?.evek?.alkalmazott || 5 }} évig</b> őrzi és kezeli; a tanuló
    belépéséhez szükséges adatokat és a digitális bizonyítványa adatait a tanulói jogviszony megszűnését követő
    <b>{{ k?.evek?.bizonyitvany || 80 }} évig</b> (Nkt. 41. § (10)–(10a)).
  </p>

  <div class="amg-figyelem" role="note">
    <ion-icon name="information-circle-outline"></ion-icon>
    <div>
      <b>Az anonimizálás vagy törlés külön döntés és művelet; ez a kimutatás csak jelzi a lejárt adatokat.</b>
      Innen semmit nem lehet törölni vagy módosítani.
    </div>
  </div>

  <div class="amg-figyelem amg-masnap" role="note" *ngIf="masikNap">
    <ion-icon name="calendar-outline"></ion-icon>
    <div>A kimutatás <b>{{ k?.nap }}</b> napra szól (mintha ma az lenne) – így látszik előre, kinek jár le az adata.</div>
  </div>

  <ion-note color="danger" class="amg-hiba" *ngIf="hiba">{{ hiba }}</ion-note>
  <div class="amg-halvany" *ngIf="fut && !k">Betöltés…</div>

  <ng-container *ngIf="k">
    <!-- ÖSSZESÍTŐ -->
    <div class="amg-csempek">
      <button type="button" class="amg-csempe" [class.be]="ful === 'tanulok'" (click)="ful = 'tanulok'">
        <span class="amg-csempe-cim">Tanulók – lejárt</span>
        <span class="amg-szam" [class.van]="k.tanulok.darab.lejart">{{ k.tanulok.darab.lejart }}</span>
        <span class="amg-kicsi amg-halvany">jogviszony vége + {{ k.tanulok.ev }} év · élő: {{ k.tanulok.darab.aktiv }} · megőrzési időn belül: {{ k.tanulok.darab.megorzesben }}</span>
      </button>
      <button type="button" class="amg-csempe amg-nyolcvan" [class.be]="ful === 'nyolcvan'" (click)="ful = 'nyolcvan'">
        <span class="amg-csempe-cim">80 éves megőrzés alatt</span>
        <span class="amg-szam">{{ k.tanulok.darab.nyolcvan_eves }}</span>
        <span class="amg-kicsi amg-halvany">10 év letelt, de digitális bizonyítványa van – nem lejártként kezelendő</span>
      </button>
      <button type="button" class="amg-csempe" [class.be]="ful === 'szulok'" (click)="ful = 'szulok'">
        <span class="amg-csempe-cim">Szülők, gondviselők – lejárt</span>
        <span class="amg-szam" [class.van]="k.szulok.darab.lejart">{{ k.szulok.darab.lejart }}</span>
        <span class="amg-kicsi amg-halvany">minden gyermekük lejárt · élő: {{ k.szulok.darab.aktiv }} · megőrzési időn belül: {{ k.szulok.darab.megorzesben }}</span>
      </button>
      <button type="button" class="amg-csempe" [class.be]="ful === 'alkalmazottak'" (click)="ful = 'alkalmazottak'">
        <span class="amg-csempe-cim">Alkalmazottak, óraadók – lejárt</span>
        <span class="amg-szam" [class.van]="k.alkalmazottak.darab.lejart">{{ k.alkalmazottak.darab.lejart }}</span>
        <span class="amg-kicsi amg-halvany">jogviszony vége + {{ k.alkalmazottak.ev }} év · élő: {{ k.alkalmazottak.darab.aktiv }} · megőrzési időn belül: {{ k.alkalmazottak.darab.megorzesben }}</span>
      </button>
      <button type="button" class="amg-csempe" [class.be]="ful === 'bizonytalan'" (click)="ful = 'bizonytalan'">
        <span class="amg-csempe-cim">Nem állapítható meg</span>
        <span class="amg-szam">{{ bizonytalanDb }}</span>
        <span class="amg-kicsi amg-halvany">jogviszony-adat vagy gyermek nélkül – nem lejárt, de érdemes rendezni</span>
      </button>
    </div>

    <!-- LISTA -->
    <section class="amg-kartya">
      <div class="amg-kartya-fej">
        <h3 [ngSwitch]="ful">
          <span *ngSwitchCase="'tanulok'">Tanulók, akiknek az adatai lejártak</span>
          <span *ngSwitchCase="'nyolcvan'">A 80 éves megőrzés alá eső volt tanulók</span>
          <span *ngSwitchCase="'szulok'">Szülők, gondviselők, akiknek az adatai lejártak</span>
          <span *ngSwitchCase="'alkalmazottak'">Alkalmazottak, óraadók, akiknek az adatai lejártak</span>
          <span *ngSwitchCase="'bizonytalan'">Akiknél a lejárat nem állapítható meg</span>
        </h3>
        <div class="amg-eszkozok">
          <input type="search" class="amg-kereso" [(ngModel)]="kereses" placeholder="Név vagy azonosító" aria-label="Keresés a listában">
          <ion-button size="small" fill="outline" (click)="csv()" *ngIf="ful !== 'bizonytalan'" [disabled]="!aktualis.length">
            <ion-icon slot="start" name="download-outline"></ion-icon>CSV
          </ion-button>
        </div>
      </div>

      <p class="amg-halvany" *ngIf="ful === 'tanulok'">
        Az utolsó tanulói jogviszony vége (az összes intézményt nézve: ha bárhol él még, nem lejárt) + {{ k.tanulok.ev }} év elmúlt,
        és digitális bizonyítványa nincs. A belépési adatokra a (10a) bekezdés 80 éves megőrzése vonatkozhat – lásd a
        „80 éves megőrzés alatt" csoportot.
      </p>
      <p class="amg-halvany" *ngIf="ful === 'nyolcvan'">
        A {{ k.tanulok.ev }} éves idő letelt, de digitális bizonyítványuk van: a belépéshez szükséges adataik és a bizonyítvány
        adatai a jogviszony megszűnését követő {{ k.evek.bizonyitvany }} évig kezelendők (Nkt. 41. § (10a), 57. § (6a)) –
        ezért <b>nem kezelendők lejártként</b>. A többi (pl. elérhetőségi, mulasztási) adatuk kezelési ideje letelt.
      </p>
      <p class="amg-halvany" *ngIf="ful === 'szulok'">
        Csak az a szülő szerepel itt, akinek MINDEN gyermeke lejárt; a mérce a legkésőbbi gyermeki jogviszony vége + {{ k.szulok.ev }} év.
      </p>
      <p class="amg-halvany" *ngIf="ful === 'alkalmazottak'">
        Minden munkáltatói jogviszonya lezárult, és a legkésőbbi vége + {{ k.alkalmazottak.ev }} év elmúlt. {{ k.alkalmazottak.megjegyzes }}
      </p>

      <ng-container *ngIf="ful !== 'bizonytalan'">
        <div class="amg-halvany" *ngIf="!aktualis.length">Ebben a csoportban nincs senki.</div>
        <div class="amg-tabla-wrap" *ngIf="aktualis.length">
          <table class="amg-tabla">
            <thead>
              <tr>
                <th>Név</th><th>Azonosító</th>
                <th *ngIf="ful === 'tanulok' || ful === 'nyolcvan'">Osztály</th>
                <th *ngIf="ful === 'szulok'" class="szam">Gyermek</th>
                <th *ngIf="ful === 'alkalmazottak'">Munkakör</th>
                <th>Jogviszony vége</th><th>Megőrzés vége</th><th>Lejárt</th>
                <th *ngIf="ful === 'nyolcvan'">Bizonyítvány</th>
                <th *ngIf="ful === 'nyolcvan'">80 év vége</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of aktualis">
                <td><b>{{ s.nev || '—' }}</b></td>
                <td class="amg-kicsi">{{ s.azonosito }}<div class="amg-halvany" *ngIf="s.felhasznalonev && s.felhasznalonev !== s.azonosito">{{ s.felhasznalonev }}</div></td>
                <td *ngIf="ful === 'tanulok' || ful === 'nyolcvan'">{{ s.osztaly || '—' }}</td>
                <td *ngIf="ful === 'szulok'" class="szam">{{ s.gyermekek }}</td>
                <td *ngIf="ful === 'alkalmazottak'">{{ s.munkakor || '—' }}</td>
                <td class="amg-nowrap">{{ s.jogviszony_vege }}</td>
                <td class="amg-nowrap">{{ s.megorzes_vege }}</td>
                <td class="amg-nowrap">{{ ota(s.lejart_ota_nap) }}</td>
                <td *ngIf="ful === 'nyolcvan'" class="szam">{{ s.digitalis_bizonyitvany }}</td>
                <td *ngIf="ful === 'nyolcvan'" class="amg-nowrap">{{ s.nyolcvan_eves_vege }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-container *ngIf="ful === 'bizonytalan'">
        <h4>Tanulók jogviszony-adat nélkül ({{ k.tanulok.darab.nem_megallapithato }})</h4>
        <div class="amg-halvany" *ngIf="!bizonytalanTanulok.length">Nincs ilyen tanuló.</div>
        <ul class="amg-lista" *ngIf="bizonytalanTanulok.length">
          <li *ngFor="let s of bizonytalanTanulok"><b>{{ s.nev || '—' }}</b> <span class="amg-halvany">{{ s.azonosito }}</span></li>
        </ul>
        <h4>Szülők, gondviselők ({{ k.szulok.darab.nem_megallapithato }})</h4>
        <div class="amg-halvany" *ngIf="!bizonytalanSzulok.length">Nincs ilyen szülő.</div>
        <ul class="amg-lista" *ngIf="bizonytalanSzulok.length">
          <li *ngFor="let s of bizonytalanSzulok"><b>{{ s.nev || '—' }}</b> <span class="amg-halvany">{{ s.azonosito }} · {{ s.ok }}</span></li>
        </ul>
      </ng-container>

      <p class="amg-halvany amg-kicsi" *ngIf="csonkolva">
        A lista az első {{ k.lista_max }} sort mutatja; a darabszám a teljes kört jelzi.
      </p>
    </section>

    <section class="amg-kartya amg-jog">
      <h3>A jogszabály szövege</h3>
      <p><b>41. § (10)</b> {{ k.jogszabaly.bekezdes_10 }}</p>
      <p><b>41. § (10a)</b> {{ k.jogszabaly.bekezdes_10a }}</p>
      <p class="amg-halvany amg-kicsi">{{ k.jogszabaly.forras }}</p>
    </section>
  </ng-container>
</div>
